<div class="container product-application-container">
    <form [formGroup]="yourProductApplicationForm" autocomplete="off" role="form" class=" ">
        <div class="float-left bg-white card-background-copy" id="modal-dialog" tabindex="-1">
            <div class=" row">
                <app-content-top-nav #topNavbar [enableBackNav]='true' [visibleBackNav]="!isViewOnly && !isHOView"
                    [visibleSaveProgress]="false" (onBackClickHandler)="onBackClick()">
                </app-content-top-nav>
            </div>
            <div class="row">
                <div class="col-md-12 clear-all title-inner-container">
                    <h1 id="yourPA-header" class="custom-header-h2 responsive-text-8">{{contentData.header}}</h1>
                </div>
            </div>
            <div class="content-container">
                <div class=" row">
                    <p class="The-Financial-Conduc" id="yourPA-introduction">{{contentData.introduction}}</p>
                </div>
                <div class="row">
                    <p class="Annuitants-details" id="yourPA-productHeader">{{contentData.productDetailsHeader}}</p>
                </div>
                <div class="row">
                    <ng-container *ngFor="let data of productDetailsSection">
                        <ng-container *ngFor="let control of data['section']">
                            <div class="col-md-12 clear-all flex-container" *ngIf="getVisibility(control.visibility)">
                                <div class="col-md-4 field flex-60">
                                    <p class="question-font" [id]="'lbl'+control.storeControlName">{{control.label}}</p>
                                </div>
                                <div class="col-md-7 value flex-40">
                                    <p class="text-color values-font" [id]="control.storeControlName">
                                        {{getProductDetails(control.label,control.storeControlName)}}</p>
                                </div>
                            </div>
                        </ng-container>

                        <div class="col-md-11 line-border"
                            *ngIf="getSectionVisibility(data['section'], selectedProductCode)">
                        </div>

                    </ng-container>
                </div>
                <div class="row" *ngIf="lifestyleStatementFlag">
                    <p class="Your-pension-has-bee" id="yourPA-productHeader">{{contentData.disclosureStatement}}</p>
                </div>
                <div class="row container-margin-top">
                    <p class="Your-pension-has-bee" id="yourPA-productHeader">{{contentData.reminderStatement}}</p>
                </div>
                <div class="row">
                    <div class="float-left summaryBtn-padding">
                        <button id="btnViewSummary" (click)="viewSummary()" style="margin-right: 0px !important;"
                            class="btn btn-primary" type="button">{{contentData.btnViewSummary}}</button>
                    </div>
                </div>
                <!-- document section -->
                <div class="row container-margin-top">
                    <!-- Key Features PDF -->
                    <div class="col-md-3">
                        <div class="container Container">
                            <div class="row row-position">
                                <div class="col-md-7 col-position1">
                                    <div class="row Key-Features">
                                        <span role="heading" aria-level="3">{{cmsData1.keyFeature2}}</span>
                                    </div>
                                    <div class="row PDF-XXXMB2">
                                        <span>{{this.keyFeatureSize}}</span>
                                    </div>
                                </div>
                                <div class="col-md-5 col-position2">
                                    <a>
                                        <img id="keyFeaturePdf" tabindex="0" (keyup.enter)="handlePDFDetails(1)"
                                            alt="key feature PDF" src="assets/images/guide.png"
                                            srcset="assets/images/guide@2x.png 2x,assets/images/guide@3x.png 3x"
                                            class="Guide reflect" (click)="handlePDFDetails(1)">
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                    <!--Terms and Conditions -->
                    <div class="col-md-3 ">
                        <div class="container Container">
                            <div class="row row-position">

                                <div class="col-md-7 col-position1">
                                    <div class="row Key-Features">
                                        <span role="heading" aria-level="3">{{cmsData1.keyFeature3}}</span>
                                    </div>
                                    <div class="row PDF-XXXMB3">
                                        <span>{{this.termsAndConditionsSize}}</span>
                                    </div>
                                </div>
                                <div class="col-md-5 col-position2">
                                    <a>
                                        <img id="termsAndConditionPdf" tabindex="0" (keyup.enter)="handlePDFDetails(2)"
                                            alt="terms and condition PDF" src="assets/images/guide.png"
                                            srcset="assets/images/guide@2x.png 2x,assets/images/guide@3x.png 3x"
                                            class="Guide reflect" (click)="handlePDFDetails(2)">
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                    <!--scamsLeaflet -->
                    <div class="col-md-3 ">
                        <div class="container Container">
                            <div class="row row-position">

                                <div class="col-md-7 col-position1">
                                    <div class="row Key-Features">
                                        <span role="heading" aria-level="3">{{cmsData1.keyFeature4}}</span>
                                    </div>
                                    <div class="row PDF-XXXMB4">
                                        <span>{{this.scamsLeafletSize}}</span>
                                    </div>
                                </div>
                                <div class="col-md-5 col-position2">
                                    <a>
                                        <img id="PensionScamPdf" tabindex="0" (keyup.enter)="handlePDFDetails(3)"
                                            alt="pension Scam PDF" src="assets/images/guide.png"
                                            srcset="assets/images/guide@2x.png 2x,assets/images/guide@3x.png 3x"
                                            class="Guide reflect" (click)="handlePDFDetails(3)">
                                    </a>
                                </div>


                            </div>
                        </div>
                    </div>
                    <!-- personalised quote -->
                    <div class="col-md-3 ">
                        <div class="container Container">
                            <div class="row row-position">

                                <div class="col-md-7 col-position1">
                                    <div class="row Key-Features">
                                        <span role="heading" aria-level="3">{{cmsData1.keyFeature1}}</span>
                                    </div>
                                    <div class="row  pdf-size1">
                                        <span>{{this.getYourPersonalisedQuoteSize()}}</span>
                                    </div>
                                </div>
                                <div class="col-md-5 col-position2">
                                    <a>
                                        <img id="personalisedQuotePdf" src="assets/images/guide.svg"
                                            alt="personalised Quote PDF" class="Guide reflect"
                                            (click)="handlePDFDetails(4)" tabindex="0"
                                            (keyup.enter)="handlePDFDetails(4)">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- documents section end-->
                <!-- -->
                
            </div>
        </div>
        <!-- Second Page Starts -->
        <div class="modal card-background-copy" id="modal-dialog" tabindex="-1">
            <div class="float-left bg-white w-100 confirm-page">
                <div class="row">
                    <div class="col-md-12 clear-all title-inner-container">
                        <h1 [innerHTML]="contentData.confirmText" id="yourPA-header" class="header"></h1>
                    </div>
                </div>
                <!--declaration section starts-->
                <div class="declaration-outer-section">
                    <div class="declaration-inner-section">
                        <span class="font-weight-200" id="yourPA-productHeader">{{declarationSection.scrollText}}</span>
                        <div class="margin-top-15">
                            <span class="text-style-2" id="yourPA-declarationHeader">
                                {{selectedProductCode !== 'C' ? declarationSection.declarationTextGI :
                                declarationSection.declarationText}}</span>
                        </div>
                        <div class="question-info col-md-12 margin-top-15 warning">
                            <i class="icon icon-error" aria-hidden="true"></i>
                            <small id="yourPA-productHeader" [innerHTML]="declarationSection.introductionText"></small>
                        </div>
                        <ng-container *ngIf="selectedProductCode === 'C'">
                            <div>
                                <span [innerHTML]="declarationSection.html_LTADP_DeclarationWording"></span>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="selectedProductCode !== 'C'">
                            <div>
                                <span [innerHTML]="declarationSection.html_GI_DeclarationWording"></span>
                            </div>
                        </ng-container>
                        <div class="col-md-12 accept-checkboxContainer">
                            <div class="col-md-1 padding-top-10">
                                <input type="checkbox" id="chkAgree" class="form-control" formControlName="chkAgree"
                                    aria-invalid="false" [attr.disabled]="(isViewOnly || isHOView) ? true : null"
                                    (change)="onAgreeCheckChange($event)" [checked]="((isHOView == true) || (isViewOnly == true))" />
                                <label for="chkAgree" class="form-label wd-25"></label>
                            </div>
                            <span id="agreeText" class="clear-all col-md-10 accept-checkboxLabel padding-top-10">
                                {{declarationSection.agreeText}}
                            </span>
                        </div>
                        <div id="agreeError"  class="row error-flex-container form-validation-error"
                            *ngIf="AgreeErrorValidatorFlag">
                            <!-- style="width: 550px" -->
                            <i class="icon icon-error" aria-hidden="true"></i>
                            <p id="agreeStatementError" aria-hidden="false" role="error" class="clickToSignError">{{contentData.agreeErrorMessage}}
                            </p>
                        </div>
                
                    </div>
                </div>
                <!--declaration section ends-->
                <!--form completion section starts-->
                <div class="content-container border-bottom">
                    <div class="col-md-12 clear-all Form-completion-Here">
                        <div class="text-style-1">
                            <span id="yourPA-productHeader">{{formCompletionSection.header}}</span>
                        </div>
                        <div class="para-margin-top">
                            <span id="">{{formCompletionSection.introduction}}</span>
                        </div>
                    </div>
                    <div class="row" *ngIf="formCompletionSection && formCompletionSection['updatesVia'] && formCompletionSection['updatesVia'].length > 0">
                        <div class="marketing-flex-container">
                            <ng-container *ngFor="let update of formCompletionSection['updatesVia']">
                                <div class="col-md-12 updates-checkBoxContainer margin-top-15">
                                    <div class="col-md-1 clear-all padding-top-10">
                                        <input type="checkbox" [attr.disabled]="(isViewOnly || isHOView) ? true : null"  [id]="update.code"
                                            class="form-control " [formControlName]="update.controlName" value="true" aria-invalid="false" />
                                        <label [for]="update.code"  class="form-label wd-25"></label>
                                    </div>
                                    <span [id]="update.code + 'Text'" class="clear-all col-md-10 updatsLabel">{{update.text}}</span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="col-md-12 clear-all If-now-or-at-any-tim">
                        <div class="para-margin-top">
                            <span id="yourPA-productHeader">{{formCompletionSection.exampleInfo}}</span>
                        </div>
                        <div class="para-margin-top">
                            <span [innerHTML]="formCompletionSection.withdrawText"></span>
                        </div>
                        <div class="para-margin-top">
                            <span [innerHTML]="formCompletionSection.reviewText1"></span>
                        </div>
                        <div class="para-margin-top">
                            <span [innerHTML]="formCompletionSection.reviewText2"></span>
                        </div>
                    </div>
                    <div class="col-md-12 sign-checkBoxContainer margin-top-70">
                        <div class="col-md-2 padding-top-28">
                            <input type="checkbox" id="chkSign" class="form-control " aria-invalid="false" formControlName="chkSign"
                                [attr.disabled]="(isViewOnly || isHOView) ? true : null" (change)="onSignCheckChange($event)" />
                            <label for="chkSign" class="form-label wd-25"></label>
                        </div>
                        <span id="signText" class="clear-all col-md-7 Click-to-sign">
                            {{contentData.clickSignText}}
                        </span>
                    </div>
                    <div id="signError"  class="col-md-12 form-validation-error error-flex-container" *ngIf="signErrorValidatorFlag">
                        <!-- style="width: 500px;margin-left: 40px !important" *ngIf="signErrorValidatorFlag" -->
                        <i class="icon icon-error" aria-hidden="true"></i>
                        <p id="clickToSignError" class="clickToSignError" aria-hidden="false" role="error">{{contentData.signErrorMessage}}</p>
                    </div>
                </div>
                <!--form completion section ends -->
                <!--form completion section ends -->
                <div class="col-md-12 clear-all">
                    <div class="float-right" *ngIf="!applyForHo && !isHOView">
                        <app-content-bottom-nav *ngIf="!loadingFlag" (onNextHandler)="submit()"
                            [userInputDetail]="afterApplyDetail['buttonConfigProductApplication']"
                            [buttonType]="'chevronCTA'"></app-content-bottom-nav>
                        <div *ngIf="loadingFlag" class="col-md-12" style="margin-top:50px">
                            <button class="btn btn-cta btn-loading float-right mar-zindex" type="button">
                                <span class="btn-text">{{generalConstants.lblCTA}}</span>
                                <div class="spinner spinner-white">
                                    <div class="spinner-ring" aria-hidden="true"></div>
                                    <span class="access">{{generalConstants.lblLoading}}</span>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Second Page Ends -->
        <app-application-summary *ngIf="viewSummaryFlag" [productCode]="selectedProductCode"
            (topNavCloseBtn)="cancelCloseModal()" (bottomNavCkoseBtn)="cancelCloseModal()"
            [submittedFlag]="isViewOnly"></app-application-summary>

    </form>
</div>